import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="136"
      height="48"
      viewBox="0 0 352 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5308 128 16.1458 128 18.7608 128C123.587 128 228.413 128 333.239 128C335.854 128 338.469 128 341.084 128C342.589 128 344.094 128 345.598 128C346.103 128.001 346.59 127.944 347.081 127.827C347.316 127.77 347.548 127.7 347.776 127.618C348.696 127.284 349.448 126.806 350.139 126.11C350.236 126.013 350.329 125.912 350.419 125.809C350.534 125.678 350.643 125.542 350.746 125.402C350.753 125.392 350.761 125.382 350.768 125.372C351.015 125.033 351.225 124.679 351.401 124.299C351.409 124.283 351.416 124.266 351.424 124.249C351.432 124.232 351.439 124.215 351.447 124.198C351.455 124.182 351.462 124.164 351.469 124.147C351.491 124.096 351.513 124.044 351.534 123.993C351.538 123.981 351.544 123.968 351.549 123.956C351.645 123.712 351.725 123.465 351.792 123.212C351.794 123.203 351.796 123.195 351.799 123.186C351.932 122.662 351.998 122.141 351.998 121.6C351.998 117.333 351.998 113.067 351.998 108.799C351.998 74.6665 351.998 40.5336 351.998 6.40019C351.998 2.86566 349.133 0 345.598 0C344.094 0 342.589 0 341.084 0C339.869 0 338.654 0 337.439 0C337.405 0 337.372 0 337.337 0C337.287 0 337.238 0 337.188 0C335.871 0 334.554 0 333.238 0C228.412 0 123.585 0 18.7603 0C17.4435 0 16.1272 0 14.8109 0C14.7613 0 14.711 0 14.6613 0C14.6275 0 14.5936 0 14.5592 0C13.3445 0 12.1292 0 10.9146 0C9.40975 0 7.90499 0 6.40019 0C2.86566 0 0 2.86566 0 6.40019C0 40.5336 0 74.6665 0 108.799C0 113.067 0 117.333 0 121.6C0 125.134 2.86566 128 6.40019 128C7.90612 128 9.41092 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86631 127.999 6.40196 127.999C7.90676 127.999 9.41159 127.999 10.9164 127.999C13.5314 127.999 16.1465 127.999 18.761 127.999C48.9213 127.999 191.08 127.999 221.24 127.999C223.856 127.999 338.47 127.999 341.085 127.999C342.59 127.999 344.095 127.999 345.6 127.999C346.104 128.001 346.591 127.943 347.081 127.826C347.318 127.77 347.549 127.7 347.777 127.618C348.697 127.284 349.45 126.805 350.139 126.11C350.236 126.013 350.33 125.912 350.42 125.809C350.849 125.318 351.185 124.793 351.448 124.198C351.456 124.182 351.463 124.164 351.471 124.147C351.602 123.842 351.709 123.532 351.793 123.211C351.795 123.202 351.797 123.194 351.799 123.185C351.934 122.661 351.999 122.14 351.999 121.599C351.999 117.332 351.999 113.066 351.999 108.799C351.999 108.666 351.999 108.532 351.999 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6090_22371)"
      />
      <path
        opacity="0.2"
        d="M19.6007 0C19.3207 0 19.0408 0 18.7608 0C17.4445 0 16.1277 0 14.8114 0C14.7618 0 14.7115 0 14.6618 0C14.628 0 14.5941 0 14.5602 0C13.345 0 12.1298 0 10.9151 0C9.41031 0 7.90548 0 6.40068 0C2.86559 0 0.000488281 2.86566 0.000488281 6.40019C0.000488281 40.5336 0.000488281 74.666 0.000488281 108.799C0.000488281 113.067 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86559 127.999 6.40068 127.999C7.90548 127.999 9.41031 127.999 10.9151 127.999C13.5302 127.999 16.1457 127.999 18.7602 127.999C19.0402 127.999 19.3202 127.999 19.6001 127.999V0H19.6007Z"
        fill="url(#paint1_linear_6090_22371)"
      />
      <path
        opacity="0.2"
        d="M332.399 0C332.679 0 332.959 0 333.239 0C334.556 0 335.872 0 337.189 0C337.238 0 337.288 0 337.338 0C337.372 0 337.406 0 337.44 0C338.655 0 339.87 0 341.085 0C342.59 0 344.095 0 345.599 0C349.134 0 351.999 2.86566 351.999 6.40019C351.999 40.5336 351.999 74.666 351.999 108.799C351.999 113.067 351.999 117.333 351.999 121.6C351.999 125.134 349.134 127.999 345.599 127.999C344.095 127.999 342.59 127.999 341.085 127.999C338.47 127.999 335.854 127.999 333.239 127.999C332.959 127.999 332.68 127.999 332.4 127.999V0H332.399Z"
        fill="url(#paint2_linear_6090_22371)"
      />
      <path
        d="M243.855 19.6002C243.675 19.6002 243.6 19.6753 243.6 19.8565C243.6 49.2859 243.6 78.7153 243.6 108.145C243.6 108.325 243.675 108.4 243.855 108.4C273.285 108.4 302.714 108.4 332.143 108.4C332.324 108.4 332.399 108.325 332.399 108.145C332.399 78.7153 332.399 49.2859 332.399 19.8565C332.399 19.6753 332.324 19.6002 332.143 19.6002C302.714 19.6002 273.285 19.6002 243.855 19.6002Z"
        fill="#575756"
      />
      <path
        d="M331.999 107.744C331.999 107.925 331.924 108 331.743 108C302.58 108 273.418 108 244.255 108C244.075 108 244 107.925 244 107.744C244 78.5815 244 49.4185 244 20.2561C244 20.0755 244.075 20.0004 244.255 20.0004C273.418 20.0004 302.58 20.0004 331.743 20.0004C331.924 20.0004 331.999 20.0755 331.999 20.2561C331.999 49.4185 331.999 78.5815 331.999 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M19.8565 19.5997C19.6759 19.5997 19.6008 19.6747 19.6008 19.8565C19.6008 49.2859 19.6008 78.7147 19.6008 108.144C19.6008 108.325 19.6759 108.4 19.8565 108.4C49.2859 108.4 78.7148 108.4 108.144 108.4C108.326 108.4 108.4 108.325 108.4 108.144C108.4 78.7147 108.4 49.2859 108.4 19.8565C108.4 19.6747 108.326 19.5997 108.144 19.5997C78.7148 19.5997 49.2859 19.5997 19.8565 19.5997Z"
        fill="#575756"
      />
      <path
        d="M107.745 20.2555V19.9998H20.2573"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.745 19.9998C107.925 19.9998 108 20.0749 108 20.2555C108 49.4191 108 78.581 108 107.744C108 107.925 107.925 108 107.745 108C78.5815 108 49.4191 108 20.2567 108C20.076 108 20.001 107.925 20.001 107.744C20.001 78.5815 20.001 49.4191 20.001 20.2555C20.001 20.0749 20.076 19.9998 20.2567 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M64.0006 94.8792C81.0548 94.8792 94.88 81.054 94.88 63.9998C94.88 46.9455 81.0548 33.1203 64.0006 33.1203C46.9463 33.1203 33.1211 46.9455 33.1211 63.9998C33.1211 81.054 46.9463 94.8792 64.0006 94.8792Z"
        fill="url(#paint3_linear_6090_22371)"
      />
      <path
        d="M48.6409 68.5599C51.1594 68.5599 53.201 66.5182 53.201 63.9997C53.201 61.4813 51.1594 59.4396 48.6409 59.4396C46.1224 59.4396 44.0808 61.4813 44.0808 63.9997C44.0808 66.5182 46.1224 68.5599 48.6409 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.3606 68.5599C81.8791 68.5599 83.9208 66.5182 83.9208 63.9997C83.9208 61.4813 81.8791 59.4396 79.3606 59.4396C76.8422 59.4396 74.8005 61.4813 74.8005 63.9997C74.8005 66.5182 76.8422 68.5599 79.3606 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M96.6691 98.0226C96.2571 98.4357 96.2571 99.1052 96.6691 99.5183C97.0834 99.9326 97.7506 99.9298 98.1638 99.5172C98.5775 99.1051 98.578 98.4357 98.1649 98.0226C97.7522 97.6105 97.0823 97.6105 96.6691 98.0226Z"
        fill="#575756"
      />
      <path
        d="M93.6539 98.2906C92.9218 98.2906 92.1898 98.2906 91.4577 98.2906C91.3284 98.2906 91.2759 98.2376 91.2759 98.1089C91.2759 96.3439 91.2759 94.5789 91.2759 92.8139C91.2759 92.6846 91.329 92.6321 91.4577 92.6321C93.2227 92.6321 94.9877 92.6321 96.7527 92.6321C96.8814 92.6321 96.9339 92.6852 96.9345 92.8139C96.9345 93.5459 96.9345 94.2781 96.9345 95.0113C96.9345 95.3511 97.0744 95.491 97.4142 95.491C97.754 95.491 97.8952 95.3511 97.8952 95.0113C97.8952 94.2781 97.8952 93.5459 97.8952 92.8139C97.894 92.1834 97.3832 91.6732 96.7533 91.672C94.9882 91.672 93.2232 91.672 91.4582 91.672C90.8278 91.672 90.3164 92.1834 90.3164 92.8139C90.3164 94.5789 90.3164 96.3439 90.3164 98.1089C90.3164 98.7394 90.8278 99.2508 91.4582 99.2508C92.1903 99.2508 92.9224 99.2508 93.6545 99.2508C93.9931 99.2508 94.1342 99.1108 94.1342 98.771C94.1342 98.4312 93.9926 98.2906 93.6539 98.2906Z"
        fill="#575756"
      />
      <path
        d="M67.1205 41.5998V33.2874C66.0887 33.1824 65.0484 33.1197 64.0003 33.1197C62.9476 33.1197 61.9068 33.1739 60.8806 33.2761V41.5993H67.1205V41.5998Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.6003 59.3104C37.6003 55.5314 37.6003 51.7519 37.6003 47.973C35.4548 51.4996 34.0042 55.4925 33.4177 59.7602C34.6618 59.7602 35.9058 59.7602 37.1504 59.7602C37.4682 59.7602 37.6003 59.6287 37.6003 59.3104Z"
        fill="#D0D0D0"
      />
      <path
        d="M90.8937 59.7602C92.1248 59.7602 93.3564 59.7602 94.588 59.7602C94.5801 59.7072 94.5728 59.6535 94.5649 59.6004C94.557 59.5474 94.5496 59.4938 94.5417 59.4407C93.9524 55.493 92.7214 51.9749 90.7204 48.5211C90.6188 48.3467 90.5042 48.1801 90.4004 48.0085C90.4004 51.7609 90.4004 55.515 90.4004 59.2674C90.4004 59.6157 90.5449 59.7602 90.8937 59.7602Z"
        fill="#D0D0D0"
      />
      <path
        d="M60.8806 86.3995V94.7228C61.9068 94.8256 62.9476 94.8792 64.0003 94.8792C65.0535 94.8792 66.0943 94.825 67.1205 94.7228V86.3995H60.8806Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.0742 68.2398C35.8556 68.2398 34.6369 68.2398 33.4177 68.2398C34.0042 72.5081 35.4548 76.4998 37.6003 80.0264C37.6003 76.2729 37.6003 72.5199 37.6003 68.7664C37.6003 68.3939 37.4462 68.2398 37.0742 68.2398Z"
        fill="#D0D0D0"
      />
      <path
        d="M91.0122 68.2398C90.5793 68.2398 90.4004 68.4193 90.4004 68.8505C90.4004 72.5764 90.4004 76.3017 90.4004 80.0264C92.5458 76.4998 93.9965 72.5081 94.5829 68.2398C93.3931 68.2398 92.2026 68.2398 91.0122 68.2398Z"
        fill="#D0D0D0"
      />
      <path
        d="M62.1038 94.8092C62.7337 94.8498 63.3653 94.8797 64.0009 94.8797C64.6387 94.8797 65.2692 94.8532 65.8974 94.8148V85.2713H62.1033V94.8092H62.1038Z"
        fill="url(#paint4_linear_6090_22371)"
      />
      <path
        d="M65.8973 33.1903C65.2674 33.1496 64.6358 33.1197 64.0003 33.1197C63.3625 33.1197 62.732 33.1462 62.1038 33.1846V42.7282H65.8979V33.1903H65.8973Z"
        fill="url(#paint5_linear_6090_22371)"
      />
      <path
        d="M131.856 19.5996C131.675 19.5996 131.6 19.6747 131.6 19.8564C131.6 49.2858 131.6 78.7147 131.6 108.144C131.6 108.325 131.675 108.4 131.856 108.4C161.285 108.4 190.714 108.4 220.143 108.4C220.325 108.4 220.4 108.325 220.4 108.144C220.4 78.7147 220.4 49.2858 220.4 19.8564C220.4 19.6747 220.325 19.5996 220.143 19.5996C190.714 19.5996 161.285 19.5996 131.856 19.5996Z"
        fill="#575756"
      />
      <path
        d="M219.744 20.2555V19.9998H132.257"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.744 19.9998C219.924 19.9998 219.999 20.0749 219.999 20.2555C219.999 49.4191 219.999 78.5809 219.999 107.744C219.999 107.925 219.924 108 219.744 108C190.581 108 161.418 108 132.256 108C132.075 108 132 107.925 132 107.744C132 78.5815 132 49.4191 132 20.2555C132 20.0749 132.075 19.9998 132.256 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M176 94.8792C193.054 94.8792 206.879 81.054 206.879 63.9997C206.879 46.9455 193.054 33.1203 176 33.1203C158.945 33.1203 145.12 46.9455 145.12 63.9997C145.12 81.054 158.945 94.8792 176 94.8792Z"
        fill="url(#paint6_linear_6090_22371)"
      />
      <path
        d="M160.64 68.5599C163.158 68.5599 165.2 66.5182 165.2 63.9997C165.2 61.4813 163.158 59.4396 160.64 59.4396C158.121 59.4396 156.08 61.4813 156.08 63.9997C156.08 66.5182 158.121 68.5599 160.64 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M191.36 68.5599C193.878 68.5599 195.92 66.5183 195.92 63.9998C195.92 61.4813 193.878 59.4397 191.36 59.4397C188.841 59.4397 186.8 61.4813 186.8 63.9998C186.8 66.5183 188.841 68.5599 191.36 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M208.668 98.0225C208.256 98.4357 208.256 99.1051 208.668 99.5183C209.082 99.9326 209.75 99.9298 210.163 99.5171C210.577 99.1051 210.577 98.4357 210.164 98.0225C209.751 97.6105 209.081 97.6105 208.668 98.0225Z"
        fill="#575756"
      />
      <path
        d="M205.653 98.2906C204.921 98.2906 204.189 98.2906 203.457 98.2906C203.327 98.2906 203.275 98.2375 203.275 98.1088C203.275 96.3438 203.275 94.5788 203.275 92.8138C203.275 92.6846 203.328 92.6321 203.457 92.6321C205.222 92.6321 206.987 92.6321 208.752 92.6321C208.88 92.6321 208.933 92.6851 208.933 92.8138C208.933 93.5459 208.933 94.278 208.933 95.0112C208.933 95.351 209.074 95.491 209.413 95.491C209.753 95.491 209.894 95.351 209.894 95.0112C209.894 94.278 209.894 93.5459 209.894 92.8138C209.893 92.1834 209.382 91.6731 208.752 91.672C206.987 91.672 205.222 91.672 203.457 91.672C202.827 91.672 202.315 92.1834 202.315 92.8138C202.315 94.5788 202.315 96.3438 202.315 98.1088C202.315 98.7393 202.827 99.2508 203.457 99.2508C204.189 99.2508 204.921 99.2508 205.654 99.2508C205.992 99.2508 206.133 99.1108 206.133 98.771C206.133 98.4312 205.991 98.2906 205.653 98.2906Z"
        fill="#575756"
      />
      <path
        d="M179.12 41.5998V33.2874C178.088 33.1824 177.048 33.1197 175.999 33.1197C174.947 33.1197 173.906 33.1739 172.88 33.2761V41.5993H179.12V41.5998Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.599 59.3104C149.599 55.5314 149.599 51.7519 149.599 47.973C147.454 51.4996 146.003 55.4925 145.417 59.7602C146.661 59.7602 147.905 59.7602 149.15 59.7602C149.467 59.7602 149.599 59.6287 149.599 59.3104Z"
        fill="#D0D0D0"
      />
      <path
        d="M202.893 59.7602C204.124 59.7602 205.356 59.7602 206.587 59.7602C206.579 59.7072 206.572 59.6535 206.564 59.6004C206.556 59.5474 206.549 59.4938 206.541 59.4407C205.952 55.493 204.721 51.9749 202.72 48.5211C202.618 48.3467 202.504 48.1801 202.4 48.0085C202.4 51.7609 202.4 55.515 202.4 59.2674C202.4 59.6157 202.544 59.7602 202.893 59.7602Z"
        fill="#D0D0D0"
      />
      <path
        d="M172.879 86.3995V94.7228C173.905 94.8256 174.946 94.8792 175.999 94.8792C177.052 94.8792 178.093 94.825 179.119 94.7228V86.3995H172.879Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.073 68.2398C147.855 68.2398 146.636 68.2398 145.417 68.2398C146.003 72.5081 147.454 76.4998 149.599 80.0264C149.599 76.2729 149.599 72.5199 149.599 68.7664C149.599 68.3939 149.445 68.2398 149.073 68.2398Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.012 68.2398C202.579 68.2398 202.4 68.4193 202.4 68.8505C202.4 72.5764 202.4 76.3017 202.4 80.0264C204.545 76.4998 205.996 72.5081 206.582 68.2398C205.392 68.2398 204.202 68.2398 203.012 68.2398Z"
        fill="#D0D0D0"
      />
      <path
        d="M174.102 94.8092C174.732 94.8498 175.364 94.8797 175.999 94.8797C176.637 94.8797 177.268 94.8532 177.896 94.8148V85.2713H174.102V94.8092H174.102Z"
        fill="url(#paint7_linear_6090_22371)"
      />
      <path
        d="M177.896 33.1903C177.267 33.1496 176.635 33.1197 175.999 33.1197C175.362 33.1197 174.731 33.1462 174.103 33.1846V42.7282H177.897V33.1903H177.896Z"
        fill="url(#paint8_linear_6090_22371)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6090_22371"
          x1="176"
          y1="109.076"
          x2="176"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6090_22371"
          x1="16.5595"
          y1="63.9993"
          x2="0.308842"
          y2="63.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6090_22371"
          x1="335.441"
          y1="63.9996"
          x2="351.691"
          y2="63.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6090_22371"
          x1="64.0007"
          y1="94.8797"
          x2="64.0007"
          y2="33.1196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6090_22371"
          x1="64.0006"
          y1="94.7473"
          x2="64.0006"
          y2="85.2422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6090_22371"
          x1="64.0005"
          y1="33.2522"
          x2="64.0005"
          y2="42.7572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6090_22371"
          x1="176"
          y1="94.8796"
          x2="176"
          y2="33.1196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6090_22371"
          x1="176"
          y1="94.7473"
          x2="176"
          y2="85.2422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6090_22371"
          x1="175.999"
          y1="33.2522"
          x2="175.999"
          y2="42.7572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
